'use strict';

// TODO: To remove after css refactor ????
/**
 *
 * @name: nsSelectbox
 *
 */

function NnSelectboxDirective() {

  'ngInject';

  return {
    restrict: 'A',
    link: function(scope, $element) {

      $element.on('click', function() {

        $('.selectbox, .filter-box').not($element).removeClass('open');
        $element.toggleClass('open');
        $('body').on('click', _closeSelectboxes);
      });

      scope.$on('$destroy', _onDestroy);

      /* private */
      function _closeSelectboxes(e) {

        var target = $(e.target);

        if (!target.closest('.selectbox').length) {

          $('.selectbox').removeClass('open');
        }
      }

      function _onDestroy() {

        $('body').off('click', _closeSelectboxes);
      }
    }
  };
}

export default NnSelectboxDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-selectbox.directive.js